import { render, staticRenderFns } from "./ExpensesTypeForm.vue?vue&type=template&id=742fddf6&"
import script from "./ExpensesTypeForm.vue?vue&type=script&lang=js&"
export * from "./ExpensesTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports